import { render, staticRenderFns } from "./LimpioNavbar.vue?vue&type=template&id=1f0a82f5&scoped=true&"
import script from "./LimpioNavbar.vue?vue&type=script&lang=js&"
export * from "./LimpioNavbar.vue?vue&type=script&lang=js&"
import style0 from "./LimpioNavbar.vue?vue&type=style&index=0&id=1f0a82f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0a82f5",
  null
  
)

export default component.exports